import React from 'react';
import {imagesData} from 'data/images-data';
import './image-loader.scss';

const ImageLoader = () => {
	return (
		<div className="ImageLoader">
			{imagesData.map((file, index) => {
				let imgSrc = require('assets/images/' + file).default;
				return <img key={index} src={imgSrc} alt="preload" />;
			})}
		</div>
	);
};



export default ImageLoader;